import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FieldWithBbox } from '../../../../models/transcriptExtractionData.model';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';
import { NgClass, DecimalPipe } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-itp-extraction-confidence',
  templateUrl: './itp-extraction-confidence.component.html',
  styleUrl: './itp-extraction-confidence.component.scss',
  imports: [Bind, Dialog, NgClass, PrimeTemplate, Button, DecimalPipe, TranslatePipe]
})
export class ItpExtractionConfidenceComponent {
  @Input() visible = false;
  @Input() field: FieldWithBbox | null = null;
  @Input() customExplanation: string | null = null;
  @Input() fieldsNeedingAttention = 0;
  @Output() visibleChange = new EventEmitter<boolean>();

  /**
   * Closes the modal and emits the visibility change event
   */
  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  /**
   * Gets the confidence score as a percentage
   */
  get confidencePercentage(): number {
    return this.field?.confidence ? this.field.confidence * 100 : 0;
  }

  /**
   * Gets the CSS class for the confidence badge based on the score
   */
  getConfidenceClass(): string {
    const confidence = this.field?.confidence;

    if (confidence === null || confidence === undefined) {
      return 'confidence-none';
    }

    if (confidence >= 0.9) {
      return 'confidence-high';
    } else if (confidence >= 0.7) {
      return 'confidence-medium';
    } else {
      return 'confidence-low';
    }
  }
}
